import { trans } from '@/helper/Translation';
import { forwardRef, memo } from 'react';
import { StyleSheet, Pressable as RNPressable } from 'react-native';
import { usePressableMotion } from './usePressableMotion';
import isEqual from 'lodash/isEqual';

const DEFAULTS = {
    hitSlop: 10,
    delayLongPress : 250
}

export const CorePressable = memo(forwardRef((props, ref) => {
    const {
        style, 
        light = null, 
        dark = null, 
        type = 'default', 
        inverted = false,
        noSwitch = false, 
        reduceMotion = false,
        onPressIn = () => {},
        onErrorPress = null,
        onPressOut = () => {},
        onPress = null,
        hoverTitle = null,
        disabled = false,
        keepPressable = false,
        ...rest
    } = props;
    
    const motion = usePressableMotion(props);
    const _onPress = (!disabled || keepPressable) ? onPress ?? null : onErrorPress ??null;
    
    return (
        <RNPressable
            ref={ref} 
            {...DEFAULTS} 
            style={StyleSheet.flatten([
                motion?.style,
                disabled ? { opacity: 0.5 } : null,
            ])}
            accessibilityLabel={typeof hoverTitle === 'string' ? trans(hoverTitle) : null} 
            onPressIn={motion?.onPressIn ?? undefined}
            onPressOut={motion?.onPressOut ?? undefined}
            onHoverIn={motion?.onHoverIn ?? undefined}
            onHoverOut={motion?.onHoverOut ?? undefined}
            onPress={_onPress}
            {...rest} 
        />
    );
}), isEqual);